import { escapeCsvCell } from "./csvFileHelpers";
import { getDueDatePart } from "./dueDateTime";
import { getInsuranceYearlyPremium } from "./insuranceTable";

/**
 * Import columns (stored fields). Export adds computed yearly_premium after policy_premium.
 */
export const INSURANCE_CSV_IMPORT_COLUMN_IDS = [
  "policy_number",
  "policyholder",
  "insurance_provider",
  "insured_asset",
  "asset_id",
  "vendor_id",
  "policy_period",
  "effective_date",
  "expiration_date",
  "policy_premium",
  "policy_status",
];

export const INSURANCE_CSV_COLUMN_IDS = [
  ...INSURANCE_CSV_IMPORT_COLUMN_IDS.slice(0, 10),
  "yearly_premium",
  ...INSURANCE_CSV_IMPORT_COLUMN_IDS.slice(10),
];


export const INSURANCE_CSV_HEADER_LINE = INSURANCE_CSV_COLUMN_IDS.join(",");
export const INSURANCE_CSV_IMPORT_HEADER_LINE = INSURANCE_CSV_IMPORT_COLUMN_IDS.join(",");

/**
 * @param {Record<string, unknown>} row
 * @returns {string[]}
 */
export function insuranceRecordToCsvCells(row) {
  return INSURANCE_CSV_COLUMN_IDS.map((colId) => {
    switch (colId) {
      case "effective_date":
      case "expiration_date":
        return getDueDatePart(row?.[colId]) || "";
      case "policy_premium": {
        const amt = row?.policy_premium;
        return amt != null && amt !== "" && Number.isFinite(Number(amt)) ? String(Number(amt)) : "";
      }
      case "yearly_premium": {
        const yearly = getInsuranceYearlyPremium(row);
        return yearly != null && Number.isFinite(yearly) ? String(Number(yearly.toFixed(2))) : "";
      }
      case "policy_status":
        return row?.policy_status != null && String(row.policy_status).trim() !== ""
          ? String(row.policy_status).trim()
          : "Active";
      default:
        return row?.[colId] != null ? String(row[colId]).trim() : "";
    }
  });
}

/**
 * @param {Record<string, unknown>[]} rows
 * @returns {string}
 */
export function buildInsuranceCsvExportText(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const lines = [
    INSURANCE_CSV_HEADER_LINE,
    ...list.map((row) => insuranceRecordToCsvCells(row).map(escapeCsvCell).join(",")),
  ];
  return lines.join("\r\n");
}
